const maxZoomSize = 21;
const minZoomSize = 0;
const staticMapInitialZoom = 11;
const gooleMapUrl = 'https://www.google.com/maps/search/?api=1&query=';
const googleStaticMapUrl = 'https://maps.googleapis.com/maps/api/staticmap';
export { maxZoomSize, minZoomSize, gooleMapUrl, googleStaticMapUrl, staticMapInitialZoom };
